import { postAPICall } from "../helpers/httpHelper";
import { db } from "../utils/db";
import store from "@/store";

export const fetchEntityRelationships = async (params) => {
  let appUsingMode = store.getters["auth/getAppMode"];
  let relationships = await fetchEntityRelationshipsFromLocal(params);
  if (!relationships?.length && !appUsingMode) {
    relationships = await fetchEntityRelationshipsFromDataBase(params);
  }
  return relationships;
};

export const fetchEntityNestedRelationships = async (params) => {
  const { entity_id: entityId = params.entityId } = params;
  const appUsingMode = store.getters["auth/getAppMode"];

  // Fetch initial relationships
  let relationshipsData = await fetchEntityRelationshipsFromLocal(params);
  if (!relationshipsData?.length && !appUsingMode) {
    return await fetchEntityNestedRelationshipsFromDataBase(params);
  }

  // Helper function to process relationships
  const processRelationship = (rel, id) => {
    const isParent = rel.parent_entity_id == id;
    return {
      ...rel,
      owner_type: isParent ? "PARENT" : "CHILD",
      relationship_title: isParent
        ? rel.child_relation_title
        : rel.parent_relation_title,
      relationship_slug: makeSlug(
        isParent ? rel.child_relation_title : rel.parent_relation_title
      ),
      relationship_id: isParent ? rel.child_entity_id : rel.parent_entity_id,
    };
  };

  // Process and filter initial relationships
  const processedRelationships = relationshipsData
    .map((rel) => processRelationship(rel, entityId))
    .filter(
      (rel) =>
        (rel.owner_type !== "CHILD" || rel.is_bidirectional) &&
        (rel.owner_type === "CHILD" || rel.representation === "TAB")
    );

  const alreadyExistedRelationships = new Set(
    processedRelationships.map((rel) => rel.relationship_id.toString())
  );

  // Process nested relationships
  const allEntityRelationshipsData = await db.entity_relationships.toArray();

  const finalRelationships = processedRelationships.flatMap((relationship) => {
    const relationshipId = relationship.relationship_id;

    return allEntityRelationshipsData
      .filter(
        (rel) =>
          rel.parent_entity_id == relationshipId ||
          rel.child_entity_id == relationshipId
      )
      .map((rel) => processRelationship(rel, relationshipId))
      .filter(
        (rel) =>
          rel.child_entity_id != entityId && rel.parent_entity_id != entityId
      )
      .filter((rel) =>
        params.fetchAll
          ? true
          : rel.owner_type === "PARENT" &&
            rel.representation === "FIELD" &&
            !(
              alreadyExistedRelationships.has(rel.child_entity_id.toString()) &&
              alreadyExistedRelationships.has(rel.parent_entity_id.toString())
            )
      )
      .map((rel) => ({
        ...rel,
        parent_relationship_details: relationship,
      }));
  });

  return finalRelationships;
};

export const fetchEntityRelationshipsFromLocal = async (params) => {
  let entity_id = params.entity_id || params.entityId;
  let relationships = await db.entity_relationships
    .filter(
      (rel) =>
        rel.parent_entity_id.toString() == entity_id.toString() || rel.child_entity_id.toString() == entity_id.toString()
    )
    .toArray();
  if (!params.include_type || !relationships?.length) {
    return relationships;
  }
  let entities = await db.entity.toArray();
  const entityMap = Object.fromEntries(entities.map((ent) => [ent._id, ent]));

  return relationships.map((rl) => ({
    ...rl,
    child_entity_id: entityMap[rl.child_entity_id],
    parent_entity_id: entityMap[rl.parent_entity_id],
  }));
};

export const fetchEntityRelationshipsFromDataBase = async (params) => {
  console.log("params", params);
  let entityId = params.entity_id || params.entityId;
  let response = await postAPICall(
    "GET",
    `/entities/${entityId}/relationships`,
    params
  );
  return response?.data;
};

export const fetchEntityNestedRelationshipsFromDataBase = async (params) => {
  let entityId = params.entity_id || params.entityId;
  let response = await postAPICall(
    "GET",
    `/entities/${entityId}/nested-relationships`,
    params
  );
  return response?.data;
};

export const makeSlug = (name) => {
  return name.trim().toLowerCase().replace(/\W/gi, "").split(" ").join("-");
};
